<template>
  <div
    :class="[
      {
        must: fieldObj.required == 1,
        err: fieldObj.dirty && fieldObj.invalid
      },
      fieldStyle
    ]"
  >
    <div class="m-input-content">
      <div v-if="fieldStyle == 'style1'" class="u-label">
        {{ fieldObj.displayName }}
      </div>
      <div v-if="fieldStyle == 'style2'" class="opacityText textarea-text">
        {{ fieldObj.displayName }}
      </div>

      <a-textarea
        maxlength="500"
        class="status-input textarea-input"
        :placeholder="
          fieldStyle == 'style1'
            ? fieldObj.fieldLevel == 4
              ? '请输入'
              : '请输入' + fieldObj.displayName
            : ''
        "
        @change="textChange($event)"
        v-model="inputValue"
      />
      <div
        v-if="fieldStyle == 'style2'"
        class="u-label textarea-label"
        :class="{
          moved: inputValue
        }"
      >
        {{ fieldObj.displayName }}
      </div>
    </div>
    <div class="u-reg-err-tips" v-show="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
  </div>
</template>
<script>
import textareaMixin from "../../field/new-fields/textarea";
export default {
  name: "sk-textarea",
  mixins: [textareaMixin]
};
</script>
<style lang=""></style>
